import { FileText, LayoutGrid, Trash2 } from "lucide-react";
import type { CanvasListItem } from "../../tars-hooks/useCanvasList";

const CANVAS_TYPE_ICONS: Record<string, typeof FileText> = {
    thinkSpace: FileText,
    analytics: LayoutGrid,
};

const SELECTED_BG = "rgba(106, 249, 49, 0.15)";
const SELECTED_BORDER = "#6AF931";

function canvasListIcon(type: string | undefined) {
    const Icon = type ? CANVAS_TYPE_ICONS[type] : LayoutGrid;
    return Icon ?? LayoutGrid;
}

interface CanvasListModalRowProps {
    canvas: CanvasListItem;
    isSelected: boolean;
    isDeleting: boolean;
    onSelect: () => void;
    onDelete: () => void;
}

export default function CanvasListModalRow({
    canvas,
    isSelected,
    isDeleting,
    onSelect,
    onDelete,
}: CanvasListModalRowProps) {
    const Icon = canvasListIcon(canvas.type);

    return (
        <div
            className={`flex h-11 w-full items-center gap-1 rounded-lg px-3 text-[14px] transition-all ${
                isSelected
                    ? "border border-emerald-300 bg-white shadow-sm"
                    : "border border-transparent bg-white/80 hover:border-emerald-200 hover:bg-white hover:shadow-sm"
            }`}
            style={{
                borderLeftWidth: isSelected ? 3 : undefined,
                borderLeftColor: isSelected ? SELECTED_BORDER : undefined,
                backgroundColor: isSelected ? SELECTED_BG : undefined,
            }}
        >
            <button
                type="button"
                onClick={onSelect}
                className="flex min-w-0 flex-1 items-center gap-2 text-left"
                style={{
                    fontWeight: isSelected ? 600 : 500,
                    color: isSelected ? "#1b1b1d" : "#374151",
                }}
            >
                <Icon size={18} strokeWidth={1.5} className="shrink-0" />
                <span className="truncate">{canvas.name}</span>
            </button>
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                }}
                disabled={isDeleting}
                className="shrink-0 rounded-md p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 disabled:opacity-50"
                aria-label={`Delete ${canvas.name}`}
            >
                <Trash2 size={16} strokeWidth={2} aria-hidden />
            </button>
        </div>
    );
}
